import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'NumbersIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-numbers",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M8 10v-7l-2 2"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6 16a2 2 0 1 1 4 0c0 .591 -.601 1.46 -1 2l-3 3h4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M15 14a2 2 0 1 0 2 -2a2 2 0 1 0 -2 -2"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6.5 10h3"
    }, null), _createTextVNode(" ")]);
  }
};